export const inputTypes = {
   textField: 'textField',
   select: 'select',
   comment: 'comment',
   location: 'location',
   autoComplete: 'autoComplete'
 }


// WEBPACK FOOTER //
// ./src/utils/inputTypes.js